import { NgModule } from '@angular/core';
import { SingularModule } from './singular/singular.module';
import { TIKTOK_CONFIG, TikTokConfig, TikTokService } from './tiktok/tiktok.service';

@NgModule({
   imports: [SingularModule],
   exports: [],
   providers: [
      {
         provide: TIKTOK_CONFIG,
         useValue: {
            enabled: true,
            currency: 'MXN',
            debugMode: true,
         } as TikTokConfig,
      },
      TikTokService,
   ],
})
export class AnalyticsModule {}
